export const REGEX_GENERIC = '^[^\\s:ñÑ\u00E0-\u00FC]';

export const REGEX_GENERIC_WITH_SPACES = '^[^:ñÑ\u00E0-\u00FC]';

export default null;
